import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Invoices from "@/pages/Invoices";
export const Route = createFileRoute("/invoices")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><Invoices /></ProtectedRoute>) });
